import React, { useState, useMemo, useEffect } from 'react';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';

function AutoSearch(props) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selected, setSelect] = useState('')
    const [open, setOpen] = useState(false)

    const filtered = useMemo(() => {
        if (searchTerm.length < 3) return [];
        
        const lowerSearchTerm = searchTerm.toLowerCase();
        return props.data.filter(item => props.filterKeys.some(key => item[key].toLowerCase().startsWith(lowerSearchTerm)));
    }, [searchTerm, props.data]);

    const handleSelect = (event, value) => {
        if (value) {
        props.setSelected(value)
        setSelect(value)
        }
    };

    return (
        <Autocomplete
        sx={props.style}
        options={filtered}
        getOptionLabel={(option) => option!==''? props.getLabel(option):''}
        renderInput={(params) => <TextField {...params} label="Rechercher ..." />}
        value={selected}
        onInputChange={(event, newInputValue) => {
            setSearchTerm(newInputValue);
            setOpen(newInputValue.length>2)
        }}
        onChange={handleSelect}
        filterOptions={(x) => x} // Désactive le filtrage interne d'Autocomplete
        noOptionsText={searchTerm.length>1&&"Aucun résultat"}
        open={open}
        onOpen={()=>setOpen(searchTerm.length>1)}
        onClose={()=>setOpen(false)}
        />
    );
}

export default AutoSearch;